import main from './main'

export class teras extends main{

   constructor (args) {
      super(args)
      this.name = 'simgeped.biomedia.net.tesoreria'
      this.version = '2502.001'
      this.urlsite = (process.env.NODE_ENV != 'development') ? document.location.origin + '/simgeped-tesoreria/' : ''
      this.page = {
         title: 'Home'
      }

      this.apiUrl = 'https://api.biomedia.net/201806/'
      this.mysql = {
         composer:'db',
         adapter:'bm',
         database:'bm_limmsy_simgeped'
      }
   
      
      this.utente = {id:'',email:''}
      super.init()
      return this
   }

 
}
export default new teras
